<span
  class="center online-support-header-span acc-title categoriesSearch p-relative"
  >
  <h3 class="searchLable">What can we help you find?</h3>

  <label>
    <input
      type="text"
      #searchInput
      [ngModel]="searchQuery"
      (input)="search(searchInput.value)"
      (keydown.enter)="openResultPage(searchInput.value)"
      aria-controls="results"
      aria-autocomplete="both"
      autocomplete="off"
      class="searchQuery"
      placeholder="I want to find..."
      (click)="showDropdown = true"
      />

    <button
      role="presentation"
      class="search-icon"
      [disabled]="searchInput.value.length === 0"
      >
      <img
        [src]="'/icons/search_new.svg'"
        alt="Search Icon"
        class="ospSearchIcon"
        />
    </button>
  </label>
</span>

<div class="search-dropdown" #searchDropdown>
  @if (showDropdown) {
    <div>
      @if (searchInput.value.length >= 3) {
        <ul>
          @for (searchItem of searchResults; track searchItem; let i = $index) {
            <li
              (click)="selectItem()"
              >
              @if (i <= 3) {
                <a (click)="openAccordion(searchItem)">
                  {{ searchItem.title }}</a
                  >
                }
              </li>
            }
            @if (
              searchPerformed &&
              searchResults.length == 0 &&
              searchInput.value.length >= 2
              ) {
              <li
                >
                <p class="noResultsFound"><strong>No results</strong></p>
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
